import { getMySnaps as getMySnapsApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import type { GetMySnapsServiceRequest, GetMySnapsServiceResponse } from './get-my-snaps.dto';
import {
  GetMySnapsServiceRequestSchema,
  GetMySnapsServiceResponseSchema,
} from './get-my-snaps.dto';

export const getMySnapsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetMySnapsServiceRequestSchema),
    async (request: GetMySnapsServiceRequest): Promise<GetMySnapsServiceResponse> => {
      const apiResponse = await getMySnapsApi({
        page: request.page,
        size: request.size,
      });

      const { list } = apiResponse;
      const hasNextPage = list.length >= request.size;
      const total = 0;

      return {
        list: list.map((snap) => ({
          id: String(snap.id),
          imageUrls:
            snap.imageUrls && snap.imageUrls.length > 0
              ? snap.imageUrls
              : snap.imageUrl
                ? [snap.imageUrl]
                : [],
          linkUrl: snap.linkUrl,
          goods: snap.goods.map((g) => ({
            goodsNo: String(g.goodsNo),
            goodsName: g.goodsName,
            brandId: g.brandId,
            brandName: g.brandName,
            brandLinkUrl: g.brandLinkUrl,
            linkUrl: g.linkUrl,
            imageUrl: g.imageUrl,
            normalPrice: g.normalPrice,
            price: g.price,
            couponPrice: g.couponPrice ?? null,
            couponSalesRate: g.couponSalesRate ?? null,
            extraDiscountAmount: g.extraDiscountAmount ?? 0,
            finalPrice: g.finalPrice ?? g.couponPrice ?? g.price,
            finalDiscount: g.finalDiscount ?? g.couponSalesRate ?? g.salesRate ?? 0,
            isLowestPrice: g.isLowestPrice ?? false,
            isExclusive: g.isExclusive ?? false,
            salesRate: g.salesRate,
            isLiked: g.isLiked ?? false,
            isSoldOut: g.isSoldOut,
            hasOptionPrice: g.hasOptionPrice ?? null,
          })),
        })),
        total,
        pagination: {
          currentPage: request.page,
          pageSize: request.size,
          hasNextPage,
          nextPage: hasNextPage ? request.page + 1 : undefined,
        },
      };
    },
    validateServiceResponse(GetMySnapsServiceResponseSchema),
  ),
);
